import { isNil } from 'lodash-es';
import { PERMISSION } from './components/pages/sharing/utils';
import { SwarmType } from './enums';
import { SWARM_TYPE_DATA_TYPES } from './graph/constants';

export function loadSbrMeasuringPoint({ id, mpSelectorId, dataSet, initialDataType = null }) {
    if (isNil(id)) {
        return;
    }
    window.location.hash = `#${id}`;

    const measuringPointOptionElement = document.querySelector(
        `#${mpSelectorId} option[value="${id}"]`
    );

    if (!measuringPointOptionElement) {
        // Sensor was not found in the dropdown. This can be caused by hitting
        // the graph page of a sensor you don't have access to. Early returning
        // leaves the page in-tact, the user is able to select another measuring
        // point from the dropdown and continue exploring the graph.
        return;
    }

    const name = measuringPointOptionElement.textContent;
    const { swarmType, permission, deviceName } = measuringPointOptionElement.dataset;

    if (!Object.values(SwarmType).includes(swarmType)) {
        throw new Error(`Could not determine swarm type of measuring point #${id}`);
    }
    if (!Object.values(PERMISSION).includes(permission)) {
        throw new Error(`Could not determine permission of measuring point #${id}`);
    }

    dataSet.loadSensor(id, name, deviceName || null, swarmType, permission);

    if (initialDataType && SWARM_TYPE_DATA_TYPES[swarmType].includes(initialDataType)) {
        dataSet.setDatatype(initialDataType);
    }

    dataSet.checkDataUpdateNeeded(true);
}
